import { createPortal } from 'react-dom';

export default function ChatModalPortal({ children }) {
  return createPortal(children, document.body);
}
